import { defineNuxtPlugin, useNuxtApp } from '#app'
import { useGameLogger } from '#imports'

export default defineNuxtPlugin(() => {
    try {
        window.GameHub = useNuxtApp().$gameHub as typeof window.GameHub
    }
    catch (err) {
        const logger = useGameLogger()
        logger.error('Failed to initialize global GameHub', err)
    }
})
